import { getCurrentInstance } from '@vue/composition-api'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { SET_FIELD_VALUE } from '~/store/modules/shared/classifieds/form/mutation-types'
import { useStore } from '@nuxtjs/composition-api'
import { FieldChange } from '~/models/form/types'

export function useDispatchedForm() {
  const { emit } = getCurrentInstance() as any
  const store = useStore()

  const valueChanged = (name: string, value: any, _options?: any) => {
    store.commit(`${CLASSIFIED_FORM_NS}/${SET_FIELD_VALUE}`, {
      name,
      value
    })
    emit('change', { name, value })
  }

  function valuesChanged(fields: FieldChange[]) {
    for (const field of fields) {
      const { name, value } = field
      store.commit(`${CLASSIFIED_FORM_NS}/${SET_FIELD_VALUE}`, {
        name,
        value
      })
    }

    // eslint-disable-next-line no-console
    console.warn('emit not implemented for dispatched valuesChanged')
  }

  return { valueChanged, valuesChanged }
}
